var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBotebasura24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aaafba;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.48,20.55c.54,0,.98-.44,.98-.98v-7.87c0-.54-.44-.98-.98-.98s-.98,.44-.98,.98v7.87c0,.54,.44,.98,.98,.98Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.09,20.55c.54,0,.98-.44,.98-.98v-7.87c0-.54-.44-.98-.98-.98s-.98,.44-.98,.98v7.87c0,.54,.44,.98,.98,.98Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.88,20.55c.54,0,.98-.44,.98-.98v-7.87c0-.54-.44-.98-.98-.98s-.98,.44-.98,.98v7.87c0,.54,.44,.98,.98,.98Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.68,3.45h-3.95c.01-.07,.04-.13,.04-.2V1.24c0-.54-.44-.98-.98-.98H7.89c-.54,0-.98,.44-.98,.98V3.25c0,.07,.03,.13,.04,.2H3.07c-1.69,0-3.07,1.38-3.07,3.07v1.73c0,.54,.44,.98,.98,.98h.96l.79,10.98c.15,2.12,1.93,3.79,4.05,3.79h10.19c2.14,0,3.92-1.67,4.06-3.81l.72-10.96h1.03c.54,0,.98-.44,.98-.98v-1.73c0-1.69-1.38-3.07-3.07-3.07Zm-1.61,16.61c-.07,1.11-.99,1.97-2.1,1.97H6.78c-1.1,0-2.03-.86-2.1-1.96l-.76-10.62h15.85s-.7,10.61-.7,10.61ZM8.87,3.25v-1.03h5.95v1.03c0,.07,.03,.13,.04,.2h-6.03c.01-.07,.04-.13,.04-.2Zm12.93,4.02H1.96v-.75c0-.61,.5-1.11,1.11-1.11H20.68c.61,0,1.11,.5,1.11,1.11v.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBotebasura24Px);
export default __webpack_public_path__ + "static/media/icon_botebasura24px.23607c61d6a1e98b0936dc8683f5a807.svg";
export { ForwardRef as ReactComponent };